import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import { ToastContainer } from "react-toastify";

import { Page } from "./types";
import ScrollToTop from "./ScrollToTop";
import Footer from "shared/Footer/Footer";
import PageHome from "containers/PageHome/PageHome";
import Page404 from "containers/Page404/Page404";
import AccountPage from "containers/AccountPage/AccountPage";
import PageSettings from "containers/PageSetting/PageSetting";
import PageSignUp from "containers/PageSignUp/PageSignUp";
import PageLogin from "containers/PageLogin/PageLogin";
import PageVerify from "containers/PageAuthVerify/PageVerify";
import SiteHeader from "containers/SiteHeader";
import AccountSavelists from "containers/AccountPage/AccountSavelists";
import AccountPass from "containers/AccountPage/AccountPass";
import AccountBilling from "containers/AccountPage/AccountBilling";
import AccountOrder from "containers/AccountPage/AccountOrder";
import CheckoutPage from "containers/PageCheckout/CheckoutPage";
import PageDashboard from "containers/PageDashboard/PageDashboard";
import PageEvents from "containers/PageEvents/PageEvents";
import PageEventDetail from "containers/PageEventDetail";
import PageBooking from "containers/PageBooking";
import PageInvoice from "containers/PageInvoice";
import PageExhibitors from "containers/PageExhibitors";
import PageTermsConditioins from "containers/PageTermsConditions";
import PageExhibitorInformation from "containers/PageExhibitorInformation";
import PageBoothStaff from "containers/PageBoothStaff";
import PageExhibitorDelegate from "containers/PageExhibitorDelegates";
import PageOrderFurniture from "containers/PageOrderFurniture";
import PageOrderBasket from "containers/PageOrderBasket";
import PageOrderHistory from "containers/PageOrderHistory";
import PageOrderElectric from "containers/PageOrderElectric";
import PageOrderAV from "containers/PageOrderAV";
import PageAdditionalServices from "containers/PageAdditionalServices";
import PageForgotPassword from "containers/PageForgotPassword/PageForgotPassword";
import PageResetPassword from "containers/PageResetPassword/PageResetPassword";

export const pages: Page[] = [
  { path: "/", component: PageHome },

  { path: "/signup", component: PageSignUp },
  { path: "/login", component: PageLogin },
  { path: "/verify-email/:token", component: PageVerify },
  { path: "/forgot-password", component: PageForgotPassword },
  { path: "/reset-password", component: PageResetPassword },

  //////////////////////////////////////////////
  { path: "/events", component: PageEvents },
  // { path: "/floorplans/:id", component: PageEventDetail },//events
  { path: "/booking", component: PageBooking },
  { path: "/invoice", component: PageInvoice },
  { path: "/exhibitors/:id", component: PageExhibitors },
  { path: "/terms-and-conditions/:id", component: PageTermsConditioins },//events

  { path: "/account", component: AccountPage },
  { path: "/dashboard", component: PageDashboard },
  { path: "/exhibitor-information", component: PageExhibitorInformation },
  { path: "/register-booth-staff", component: PageBoothStaff },
  { path: "/register-exhibitor-delegates", component: PageExhibitorDelegate },
  { path: "/order-furniture", component: PageOrderFurniture },
  { path: "/order-electrics", component: PageOrderElectric },
  { path: "/order-audio-visual", component: PageOrderAV },
  { path: "/additional-services", component: PageAdditionalServices },
  { path: "/order-basket", component: PageOrderBasket },
  { path: "/order-review", component: PageOrderHistory },
  { path: "/checkout", component: CheckoutPage },
  { path: "/account-my-order", component: AccountOrder },
  { path: "/account-savelists", component: AccountSavelists },
  { path: "/account-change-password", component: AccountPass },
  { path: "/account-billing", component: AccountBilling },
  { path: "/settings", component: PageSettings },
];

const MyRoutes = () => {
  return (
    <BrowserRouter>
      {/* react-hot-toast */}
      <Toaster />
      {/* react-toastify notification */}
      <ToastContainer />
      <ScrollToTop />
      <SiteHeader />
      <Routes>
        {pages.map(({ component: Component, path }, index) => {

          return <Route key={index} element={<Component />} path={path} />;
        })}
        <Route path="/floorplans/:id" element={<PageEventDetail />} />
        <Route element={<Page404 />} />
      </Routes>
      <Footer />
    </BrowserRouter>
  );
};

export default MyRoutes;
